import React, { useState, useEffect } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Button, Badge, Form } from 'react-bootstrap';
import { getPastaPromotora } from '../../../../helpers/promotoraPasta';

const Clipboardurlevento = ({evento}) => {

    const [value, setValue] = useState('');
    const [copied, setCopied] = useState(false);
    
    useEffect(() => {        
        const url = `${window.location.protocol}//${window.location.host}/app/credenciamento/${getPastaPromotora(evento.idpromotora)}/${evento.ideventocriptografado}`;
        setValue(url);
    },[evento]);

    useEffect(() => {
        if(copied===true){
            setTimeout(() => setCopied(false), 3000);
        }
    },[copied])
    
    return (
        <>
            <Form.Row>                
                <CopyToClipboard text={value} onCopy={() => setCopied(true)}>
                <Button variant="outline-primary" size="sm">                    
                    {copied ? "Copiado!":"Copiar URL"}
                </Button>
                </CopyToClipboard>
                <Badge variant="secondary">{value}</Badge>
            </Form.Row>
            <Form.Row>
                
            </Form.Row>
        </>
    );
}

export default Clipboardurlevento;